import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import DynamicTable from "../../../components/DynamicTable";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
  Breadcrumbs,
  Typography,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

//cookies
import { get_cookies } from "../../../components/Cookies/Cookies";
import numeral from "numeral";
import { checkDateRange } from "../../../services/utils";
import MessageBox from "../../../components/MessageBox/MessageBox";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const SalesReturnHistory = () => {
  const refDataFilter = React.createRef();
  const [uniqueID, setUniqueId] = useState("");
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const classes = useStyles();

  const [checkMaxDays, setCheckMaxDays] = useState(false);

  const [useridNo, setuseridNo] = useState(get_cookies("branchidno"));

  const url = "sr_transaction_history";

  const onFetchedApi = () => {
    refDataFilter.current.onFetchApi();
  };

  // Data Fetching
  useEffect(() => {
    // data();
    onFetchedApi();
  }, []);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);

  //search button
  const dataFilter = async () => {
    setDataLoaded(false);
    await axios
      .get(process.env.REACT_APP_API_URL + "sr_transaction_history", {
        params: {
          date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: format(dateRange.endDate, "yyyy-MM-dd"), //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_user_id_no: useridNo,
          unique_id: uniqueID,
        },
      })
      .then((res) => {
        setPosts(res.data.data);
      })
      .catch((error) => {
        // console.log(error.message);
      });
    setDataLoaded(true);
  };

  const data = async () => {
    setDataLoaded(true);
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    if (checkDateRange(range.endDate, range.startDate) <= 30) {
      setDateRange(range);
    } else {
      setCheckMaxDays(true);
      setTimeout(() => {
        setCheckMaxDays(false);
      }, 6000);
    }

    setOpen(false);
  };
  const columns = [
    {
      name: "date",
      label: "Date",
    },
    {
      name: "return_no",
      label: "Return No",
    },
    {
      name: "name",
      label: "Name",
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        customBodyRenderLite: (dataIndex, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(posts[dataIndex].amount).format("0,0.00")}
            </div>
          );
        },
      },
    },
    {
      name: "balance",
      label: "Balance",
      options: {
        customBodyRenderLite: (dataIndex, tableMeta, updateValue) => {
          const balanceAmount = posts[dataIndex].balance;
          let showBalance;
          if (balanceAmount == 0) {
            showBalance = (
              <div style={{ textAlign: "right" }}>
                {numeral(posts[dataIndex].amount).format("0,0.00")}
              </div>
            );
          } else {
            showBalance = (
              <div style={{ textAlign: "right" }}>
                {numeral(posts[dataIndex].balance).format("0,0.00")}
              </div>
            );
          }

          return showBalance;
        },
      },
    },
    {
      name: "status",
      label: "Status",
    },
    {
      name: "action",
      label: "Action",
      options: {
        download: false, //exclude this column in csv export
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          let drretno = posts[dataIndex].return_no;
          let status = posts[dataIndex].status;
          // if($rowrecord["ispaid"]=="Full Allocation")
          // {
          //     $echo.='<a class="table-actions" onclick="salesreturnviewdetails('.$rowrecord["drretno"].');"><i class="fa fa-eye"></i></a>';
          // }
          // else
          // {
          //     $echo.='<a class="table-actions" onclick="salesreturnviewdetails('.$rowrecord["drretno"].');"><i class="fa fa-eye"></i></a>';
          //     $echo.='<a class="table-actions" onclick="salesreturnallocate('.$rowrecord["drretno"].');"><i class="fa fa-external-link-square"></i></a>';
          // }
          if (status === "Full Allocation") {
            return (
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={6} lg={5} xl={4}>
                  <NavLink
                    to={
                      "/sales/sales-return-history-view/" +
                      drretno +
                      "/" +
                      useridNo
                    }
                  >
                    <Button variant="contained" color="primary">
                      View
                    </Button>
                  </NavLink>
                </Grid>
              </Grid>
            );
          } else {
            return (
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
                  <NavLink
                    to={
                      "/sales/sales-return-history-view/" +
                      drretno +
                      "/" +
                      useridNo
                    }
                  >
                    <Button variant="contained" color="primary">
                      View
                    </Button>
                  </NavLink>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
                  {!get_cookies("can_process") == 1 ? (
                    <NavLink
                      to={
                        "/sales/sales-return-history-allocate/" +
                        drretno +
                        "/" +
                        useridNo
                      }
                    >
                      <Button variant="contained" color="primary">
                        Allocate
                      </Button>
                    </NavLink>
                  ) : null}
                </Grid>
              </Grid>
            );
          }
        },
      },
    },
  ];

  const options = {
    filter: true,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    download: downloadFlag, //add this
    print: downloadFlag, //add this
    downloadOptions: {
      filename: "SalesReturnHistory.csv", //change filename of csv
    },
    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Sales Return History</Typography>
				</Breadcrumbs>
      </div>
      <div className="page-container">
        <div style={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-basic"
                label="Select Date"
                variant="outlined"
                onFocus={() => setOpen(true)}
                fullWidth={true}
                autoComplete="off"
                value={`${format(dateRange.startDate, "MM/dd/yyyy")} - ${format(
                  dateRange.endDate,
                  "MM/dd/yyyy"
                )}`}
              />
              <DateRangePicker
                open={open}
                toggle={toggle}
                onChange={(range) => dateRangeHandler(range)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-search"
                label="Search by ID"
                type="search"
                variant="outlined"
                value={uniqueID}
                onChange={(e) => {
                  setUniqueId(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={1} lg={1} xl={1}>
              {/* <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}} >Search</Button> */}
              <Button
                variant="contained"
                style={{ marginTop: "23px" }}
                color="primary"
                onClick={() => {
                  onFetchedApi();
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </div>
        <DynamicTable
          title="Sales Return"
          columns={columns}
          rows={posts}
          setRows={setPosts}
          ref={refDataFilter}
          dateRange={dateRange}
          url={url}
        />
        {/* {!dataLoaded ? (
					<Preloader />
				) : (
						<MUIDataTable
							title={
								<div>
									<div className="table-subtitle">Table</div>
									<div className="table-title">
									Sales Return Transaction History
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				)} */}
      </div>
      <MessageBox
        in={checkMaxDays}
        content="Maximum of 30 days date range. Kindly select again."
        type="warning"
      />
    </div>
  );
};

export default SalesReturnHistory;
